// 发票状态
export enum InvoiceStatus {
    '未提交',
    '待审核',
    '审核通过',
    '已驳回',
    '已收到',
    '已付款',
    '已过期'
}

// 发票类型
export enum InvoiceType {
    '未设置',
    '专票',
    '普票',
    '无票',
    '其他',
}

// 预付款审核状态
export enum PrepayCheckStatus {
    '待审核',
    '审核通过',
    '驳回'
}